import React, {Component} from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import ActionData from '../../types/ActionData'
import { Container, Row, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import CircularProgress from '@material-ui/core/CircularProgress'
import CoupleImage from './images/couplev2.jpg'
import ForgotPassword from '../../components/Login/ForgotPassword'
import LoginUser from '../../components/Login/LoginUser'
import SetPassword from '../../components/Login/SetPassword'
import CreateAccount from '../../components/Login/CreateAccount'
import { addAppProcessUser, validateUser } from '../../redux/actions/applicationProcess'
import { authMember, loginUser, resetPassword, updateUserPassword } from '../../redux/actions/authentication'
import { sendMail } from '../../redux/actions/mail'
import './index.css'

interface RouteParams {
  page: string;
  eid: string;
}

interface Props {
  addUser: ActionData;
  authMemberData: ActionData;
  height: number;
  loginUserData: ActionData;
  mail: ActionData;
  userExists: ActionData;
  resetPasswordData: ActionData;
  updatePassword: ActionData;
  width:  number;
  addAppProcessUser: (data: { email: string; firstName: string; lastName: string; roleId: number; status: string; enabled: boolean }) => void;
  authMember: (data: { e: string; p: string; u: string }) => void;
  loginUser: (data: {email: string; password: string}) => void;
  resetPassword: (data: {email: string}) => void;
  sendMail: (data: {emailTo: string; subject: string; type: string}) => void;
  updateUserPassword: (userId: number, data: {password: string; pageType: string}) => void;
  validateUser: (data: { email: string }) => void;
}

const getUrlParameter = (name: string) => {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]') // eslint-disable-line no-useless-escape
  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  let results = regex.exec(window.location.search)
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

class Login extends Component<Props & RouteComponentProps<RouteParams>> {
  state = {
    confirmPasswordError: false,
    email: '',
    emailError: false,
    emailSent: false,
    forgotEmailError: false,
    forgotPassword: '',
    pageType: 'login',
    password: '',
    resetPassword: '',
    resetPasswordConfirm: '',
    showLoginError: false,
    updatingPassword: false,
    validPassword: true,
    // Create account
    creatingUser: false,
    createAccountError: null,
    createAccountErrorType: '',
    createAccountEmailSent: false,
    showCreateAccountError: false,
    duplicateEmail: false,
    newAccount: {
      firstName: '',
      lastName: '',
      email: ''
    }
  }
  
  componentDidMount(){
    const { match, location, authMember, resetPassword } = this.props

    this.setState({pageType:match.params.page})
		
    if((match.params.page==='reset'||match.params.page==='activate')&&location.search!==undefined){
      resetPassword({email: location.search.substring(5, location.search.length)})
    }
    else if(match.params.page==='member'){
      let data ={
        u: getUrlParameter('u'),
        p: getUrlParameter('p'),
        e: getUrlParameter('e')
      }

      authMember(data)
    }
  }
  
  componentDidUpdate(prevProps: Props&RouteComponentProps<RouteParams>){
    const { addUser, authMemberData, loginUserData, match, mail, history, userExists } = this.props

    if(prevProps.loginUserData.loading !== loginUserData.loading){
      if(loginUserData.success && !loginUserData.error){
        if(loginUserData.data !== null){
          history.push('/')
        }
        else
          this.setState({showLoginError: true})
      }
      else
        this.setState({showLoginError: true})
    }

    if(prevProps.match.params.page !== match.params.page) {
      this.setState({pageType: match.params.page, showLoginError: false, emailSent: false})
    }
    
    // Mail
    if (prevProps.mail.loading !== mail.loading && !mail.loading) {
      const { pageType } = this.state

      if(mail.success && !mail.error){
        if ( pageType === 'create' ) {
          this.setState({ 
            creatingUser: false,
            createAccountEmailSent: true, 
            showCreateAccountError: false
          })
        }
        else {
          //if(this.props.mail.data.accepted!==undefined){
          this.setState({emailSent: true, showLoginError: false})
          //}
        }
      }
      else{
        if ( pageType === 'create' ) {
          this.setState({
            creatingUser: false,
            createAccountError: mail.error.response ? mail.error : { response: { text: 'Error sending email'} },
            createAccountErrorType: 'mail',
            showCreateAccountError: true
          })
        }
        else if(mail.error && mail.error.status===500){
          this.setState({showLoginError: true})
        }
      }
    }

    // Login
    if(prevProps.authMemberData.loading !== authMemberData.loading){
      if(authMemberData.success && !authMemberData.error){
        if(authMemberData.data.length > 0){
          history.push('/')
        }
      }
    }

    // Create Account, verify if user already exists
    if(prevProps.userExists.loading !== userExists.loading && !userExists.loading) {
      if (userExists.success && !userExists.error) {
        if (userExists.data.length === 0) {
          const { newAccount } = this.state
          const { addAppProcessUser } = this.props
          addAppProcessUser({ ...newAccount, roleId: 4, status: 'created', enabled: true })

          this.setState({ creatingUser: true })
        } else {
          this.setState({ duplicateEmail: true })
        }
      } else {
        this.setState({
          createAccountError: userExists.error.response ? userExists.error : { response: { text: 'Error checking email in database'} },
          createAccountErrorType: 'validate',
          showCreateAccountError: true
        })
      }
    }

    // Create Account, send email
    if(prevProps.addUser.loading !== addUser.loading && !addUser.loading) {
      if (addUser.success && !addUser.error && addUser.data.userId ) {
        const { sendMail } = this.props
        const { newAccount } = this.state
        const data = {
          emailTo: newAccount.email,
          subject: 'Activate account',
          type: 'activate'
        }
        sendMail(data)
      } else {
        this.setState({
          creatingUser: false,
          createAccountError: addUser.error.response ? addUser.error : { response: { text: 'Error creating user in database'} },
          createAccountErrorType: 'create',
          showCreateAccountError: true
        })
      }
    }
  }

  handleOnChange = (event: any, name: string)  => {
    this.setState({[name]: event.target.value}, () => {
      const { email, resetPassword, resetPasswordConfirm, forgotPassword } = this.state
      const pattern = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/ // eslint-disable-line no-useless-escape
			
      if(name==='email'){
        const valid = pattern.test(email)
        this.setState({emailError: email!==''&&!valid})
      }
      else if(name==='resetPassword'||name==='resetPasswordConfirm'){
        this.setState({confirmPasswordError: resetPassword !== resetPasswordConfirm})
      }
      else if(name==='forgotPassword'){
        let valid = pattern.test(forgotPassword)
        this.setState({forgotEmailError: forgotPassword!==''&&!valid})
      }
    })
  }
  
  handleKeyPress = (target: any) => {
    const { loginUser } = this.props
    if(target.charCode===13){
      const { email, password, emailError } = this.state
	  
      if(email!==''&&!emailError&&password!==''){
        let data = {
          email: email,
          password: password
        }
		
        loginUser(data)
      }
    } 
  }
  
  handleSubmitEmail = () => {
    const { sendMail } = this.props
    const { forgotPassword } = this.state
		
    let data = {
      emailTo: forgotPassword,
      subject: 'Reset password',
      type: 'forgot'
    }
		
    sendMail(data)
  }
	
  handleLoginUser = () => {
    const { loginUser } = this.props
    const { email, password } = this.state
		
    let data = {
      email: email,
      password: password
    }
		
    loginUser(data)
  }
  
  handleUpdatePassword = () =>{
    const { resetPasswordData, updateUserPassword } = this.props
    const { resetPassword, pageType } = this.state
		
    let passwordPattern =  /(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%&*()]).{8,}/
    let validPassword = passwordPattern.test(resetPassword)

    if(validPassword){
      let data = {
        password: resetPassword,
        pageType
      }
			
      if(resetPasswordData.data.length > 0){//Message when no user exists with that email
        if(resetPasswordData.data[0].user_id !== undefined){
          updateUserPassword(resetPasswordData.data[0].user_id, data)
          this.setState({updatingPassword: true, validPassword})
        }
      }
    }
    else{
      this.setState({validPassword})
    }
  }
  
  handleClearPassword = () =>{
    this.setState({resetPassword:'', resetPasswordConfirm: ''})
  }
  
  handleSubmitCreateAccount = (values: any) => {
    const { validateUser } = this.props
		
    this.setState({ newAccount: values })
    validateUser({email: values.email})
  }

  handleBack = () => {
    this.setState({
      creatingUser: false,
      createAccountError: null,
      createAccountErrorType: '',
      createAccountEmailSent: false,
      showCreateAccountError: false,
      duplicateEmail: false,
      newAccount: {
        firstName: '',
        lastName: '',
        email: ''
      }
    })
  }
	
  render() {
    const { height, updatePassword, width } = this.props
    const { duplicateEmail, confirmPasswordError, email, password, emailError, emailSent, forgotEmailError, forgotPassword, pageType, resetPassword, resetPasswordConfirm, showLoginError, updatingPassword, 
      validPassword, showCreateAccountError, createAccountError, createAccountErrorType, creatingUser, createAccountEmailSent,
    } = this.state
		
    let loadingIcon = <CircularProgress size={70} />
    let resultText = 'Saving data'
		
    if(updatePassword.error!== false){
      loadingIcon = <FontAwesomeIcon icon={['fas', 'exclamation-circle']} color="#cb6767" className="login-success-icon" />
      resultText = 'The user could not be saved.'
    }
	
    return(
      <Container 
        style={{
          paddingTop:0, 
          backgroundColor: '#f5f5f5', 
          width:width, 
          height:height-20, 
          maxWidth:width, 
          overflow:'auto'
        }}>
        <Row>
          <Col lg={4} md={4} style={{paddingLeft: 0, paddingRight: 0}}>
            <div style={{backgroundImage: 'url(' + CoupleImage + ')', backgroundSize: 'auto 100%', width: '100%', height: height-20, backgroundRepeat: 'no-repeat'}}></div>
          </Col>
          <Col lg={8} md={8}>
            <div className="login-container" style={{height:height-40}}>
              <div>
                <div className="login-title">
                  <h3>Welcome to DataClarity</h3>
                  <div className="login-subtitle-container">
                    <span className="login-subtitle" >by Lakeland Care</span>
                  </div>
                  <div>
                    <hr />
                    {pageType !=='create' ? 
                      <span className='login-provider-title'>PROVIDER PORTAL</span>
                    :
                      <span className='login-provider-title'>PROVIDER APPLICATION PORTAL</span>
                    }
                    <hr />
                  </div>
                </div>
                {pageType==='forgot'? (
                  <ForgotPassword
                    emailSent={emailSent}
                    forgotEmailError={forgotEmailError}
                    forgotPassword={forgotPassword}
                    showLoginError={showLoginError} 
                    onChangeField={(e: any, name: string)=>{this.handleOnChange(e, name)}}
                    onSubmitEmail={this.handleSubmitEmail}
                  />
                ): pageType==='create'? (
                  <CreateAccount
                    creatingUser={creatingUser}
                    duplicateEmail={duplicateEmail}
                    emailSent={createAccountEmailSent}
                    error={createAccountError}
                    errorType={createAccountErrorType}
                    showError={showCreateAccountError}
                    onBack={this.handleBack}
                    onSubmit={this.handleSubmitCreateAccount}
                  />
                ): pageType==='reset' || pageType==='activate'? (
                  <SetPassword
                    confirmPasswordError={confirmPasswordError}
                    loadingIcon={loadingIcon}
                    pageType={pageType}
                    resetPassword={resetPassword}
                    resetPasswordConfirm={resetPasswordConfirm}
                    resultText={resultText}
                    updatePassword={updatePassword}
                    updatingPassword={updatingPassword}
                    validPassword={validPassword}
                    onChangeField={(e: any, name: string)=>{this.handleOnChange(e, name)}}
                    onClearPassword={this.handleClearPassword}
                    onUpdatePassword={this.handleUpdatePassword}
                  />
                ):(
                  <LoginUser
                    emailError={emailError}
                    email={email}
                    password={password}
                    showLoginError={showLoginError} 
                    onChangeField={(e: any, name: string)=>{this.handleOnChange(e, name)}}
                    onKeyPress={this.handleKeyPress}
                    onLoginUser={this.handleLoginUser}
                  />
                )}
              </div>
              <span className="login-copyright" >Copyright © 2019 Lakeland Care All Rights Reserved.</span>
            </div>
          </Col>
        </Row>
      </Container>
    )
  }
}

const mapStateToProps = (state: any) => ({
  addUser: state.applicationProcess.addUser,
  authMemberData: state.authentication.authMember,
  loginUserData: state.authentication.loginUser,
  mail: state.mail,
  resetPasswordData: state.authentication.resetPassword,
  updatePassword: state.authentication.updateUserPassword,
  userExists: state.applicationProcess.userExists,
})

const mapDispatchToProps = (dispatch: any) => ({
  addAppProcessUser: (data: { email: string; firstName: string; lastName: string; roleId: number; status: string; enabled: boolean }) => dispatch(addAppProcessUser(data)),
  authMember : (data: { e: string; p: string; u: string }) => dispatch(authMember(data)),
  loginUser: (data: {email: string; password: string}) => dispatch(loginUser(data)),
  resetPassword: (data: {email: string}) => dispatch(resetPassword(data)),
  sendMail: (data: {emailTo: string; subject: string; type: string}) => dispatch(sendMail(data)),
  updateUserPassword: (userId: number, data: {password: string; pageType: string}) => dispatch(updateUserPassword(userId, data)),
  validateUser: (data: { email: string }) => dispatch(validateUser(data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)